// Tablo sütunu arayüzü
export interface TableColumn {
  id: string;
  label: string;
  field: string;
  visible: boolean;
  fixed: boolean;
  sortable?: boolean;
  description?: string;
}

// Depo stok bilgisi arayüzü (YENİ - WarehouseStock tablosundan gelir)
export interface WarehouseStockDto {
  id: string;
  productId: string;
  warehouseId: string;
  warehouseName?: string;
  quantity: number;
  locationId?: string;
  locationCode?: string;
  locationName?: string;
  locationFullPath?: string;
  createdAt: string;
  updatedAt?: string;
}

// Stok ürün arayüzü
export interface InventoryItem {
  id: string;
  name: string;
  barcode?: string;
  categoryId?: string | null;
  brandId?: string | null;
  stockCode: string;
  // ❌ KALDIRILDI: quantity ve warehouseId artık WarehouseStock tablosunda
  // quantity: number; 
  // warehouseId: string | null;
  unit: string;
  purchasePrice: number;
  purchaseCurrency?: string;
  salePrice: number;
  saleCurrency?: string;
  vatRate?: number;
  vatStatus?: string;
  sctRate?: number;
  sctStatus?: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  branchesId?: string | null;
  parentItemId?: string | null;
  // LEGACY UYUM: isMainItem gecis sureci icin tutulur.
  // Parent/child kararinda parentItemId + isVariantParent kullanilmalidir.
  isMainItem?: boolean;
  isVariantParent?: boolean;
  canBeNegative?: boolean;
  departmentNo?: number | null; // Departman No eklendi
  imageUrl?: string | null; // Ürün resmi URL'si
  // ✅ YENİ: Depo stokları (opsiyonel - detay sayfasında doldurulur)
  warehouseStocks?: WarehouseStockDto[];
  isQRMenu?: boolean; // QR Menü'ye gönderildi mi?
  qrMenuSentAt?: string; // QR Menü'ye gönderilme tarihi
  qrMenuLastUpdate?: string; // QR Menü son güncelleme tarihi
  qrMenuRemovedAt?: string; // QR Menü'den kaldırılma tarihi
  isEcommerce?: boolean; // E-ticarette aktif mi?
  ecommerceActivatedAt?: string; // E-ticarete açılma tarihi
  ecommerceDeactivatedAt?: string; // E-ticaretten kapatılma tarihi
  isKiosk?: boolean; // Kiosk'ta aktif mi?
  kioskSentAt?: string; // Kiosk'a gönderilme tarihi
  kioskLastUpdate?: string; // Kiosk son güncelleme tarihi
  kioskRemovedAt?: string; // Kiosk'tan kaldırılma tarihi
  isN11?: boolean; // N11'de aktif mi?
  isPttAvm?: boolean; // PttAVM'de aktif mi?
  n11SentAt?: string; // N11'e gönderilme tarihi
  mainItemId?: string | null; // Ana ürün ID
  printerGroup?: string; // Yazıcı grubu
  // Liste fiyatı
  listPrice?: number;
  listCurrency?: string;
  // Ek alış fiyatları
  purchasePrice2?: number;
  purchaseCurrency2?: string;
  purchaseVendor?: string;
  purchaseVendor2?: string;
  purchasePrice3?: number;
  purchaseCurrency3?: string;
  purchaseVendor3?: string;
  // Ek satış fiyatları
  salePrice2?: number;
  saleCurrency2?: string;
  saleCustomer?: string;
  saleCustomer2?: string;
  salePrice3?: number;
  saleCurrency3?: string;
  saleCustomer3?: string;
  // Stok seviyeleri
  minStockLevel?: number;
  maxStockLevel?: number;
  desi?: number;
  variants?: {
    physical?: {
      color?: string | null;
      size?: string | null;
      length?: number | null;
      width?: number | null;
      height?: number | null;
      weight?: number | null;
      desi?: number | null;
      thickness?: number | null;
    } | null;
    technical?: {
      material?: string | null;
      grade?: string | null;
      model?: string | null;
      series?: string | null;
      power?: number | null;
      voltage?: number | null;
    } | null;
    design?: {
      pattern?: string | null;
      style?: string | null;
      finish?: string | null;
      shape?: string | null;
    } | null;
    capacity?: {
      capacity?: number | null;
      diameter?: number | null;
      innerSize?: string | null;
      outerSize?: string | null;
    } | null;
    usage?: {
      ageGroup?: string | null;
      gender?: string | null;
      season?: string | null;
      usage?: string | null;
    } | null;
    variety?: {
      flavor?: string | null;
      scent?: string | null;
      hardness?: string | null;
      transparency?: string | null;
    } | null;
    packaging?: {
      packQuantity?: number | null;
      packType?: string | null;
      packSize?: string | null;
    } | null;
    special?: {
      waterproof?: boolean | null;
      antibacterial?: boolean | null;
      organic?: boolean | null;
      recyclable?: boolean | null;
    } | null;
  } | null;
  // ✅ YENİ: Şube bazlı fiyatlandırma
  useBranchPricing?: boolean;
  branchPrices?: BranchPrice[];
  // ✅ YENİ: Basit Üretim Reçetesi
  hasRecipe?: boolean;
  // ✅ YENİ: Menü Tanımları
  hasMenu?: boolean;
}

// Kategori arayüzü
export interface InventoryCategory {
  id: string;
  name: string;
  parentId: string | null;
  level: number;
  createdAt: string;
  branchesId?: string | null;
}

// Marka arayüzü
export interface Brand {
  id: string;
  name: string;
  description?: string;
  website?: string;
}

// Depo arayüzü
export interface Warehouse {
  id: string;
  name: string;
  address?: string;
  description?: string;
  isDefault?: boolean;
  warehouseType?: string;
}

// Şube arayüzü
export interface Branch {
  id: string;
  name: string;
}

// ✅ YENİ: Şube bazlı fiyat arayüzü
export interface BranchPrice {
  id: string;
  companyId: string;
  inventoryItemId: string;
  branchId: string;
  branchName?: string;
  salePrice: number;
  saleCurrency: string;
  listPrice?: number;
  listCurrency?: string;
  packagePrice?: number; // ✅ YENİ: Paket fiyatı
  createdAt: string;
  updatedAt?: string;
  createdBy?: string;
  isActive: boolean;
}

// Şube bazlı fiyat oluşturma DTO
export interface CreateBranchPriceDto {
  companyId: string;
  inventoryItemId: string;
  branchId: string;
  branchName?: string;
  salePrice: number;
  saleCurrency?: string;
  listPrice?: number;
  listCurrency?: string;
  packagePrice?: number; // ✅ YENİ: Paket fiyatı
  createdBy?: string;
}

// Şube bazlı fiyat güncelleme DTO
export interface UpdateBranchPriceDto {
  id: string;
  companyId: string;
  salePrice: number;
  saleCurrency?: string;
  listPrice?: number;
  listCurrency?: string;
  packagePrice?: number; // ✅ YENİ: Paket fiyatı
  // ✅ YENİ: Fiyat değişiklik log için kullanıcı bilgileri
  userId?: string;
  userName?: string;
  branchId?: string;
  branchName?: string;
}

// Fiyat değişiklik log tipi
export interface PriceChangeLog {
  id: string;
  companyId: string;
  inventoryItemId: string;
  productName?: string;
  stockCode?: string;
  branchId?: string;
  branchName?: string;
  priceType: string; // SALE_PRICE, LIST_PRICE, PACKAGE_PRICE, PURCHASE_PRICE
  oldValue: number;
  newValue: number;
  currency: string;
  userId?: string;
  userName?: string;
  source: string; // INVENTORY, BRANCH_PRICE, BULK_UPDATE, IMPORT, N11_SYNC
  notes?: string;
  createdAt: string;
}

// Fiyat değişiklik log response tipi
export interface PriceChangeLogResponse {
  data: PriceChangeLog[];
  totalCount: number;
  page: number;
  pageSize: number;
}

// Sıralama tipi
export type Order = 'asc' | 'desc';

// LocalStorage anahtarları
export const INVENTORY_TABLE_SETTINGS_KEY = 'inventoryTableSettings';
export const HIDE_EMPTY_STOCK_KEY = 'hideEmptyStock';
export const HIDE_INACTIVE_ITEMS_KEY = 'hideInactiveItems';

// Realtime dinlemeyi kontrol etmek için global bir değişken
export let realtimeListenerActive = true;

// Realtime listener'ı açıp kapatan fonksiyon
export const setRealtimeListenerActive = (active: boolean) => {
  realtimeListenerActive = active;
};

